import { makeActionCreator } from '../../config/store/utils'
import {
  getContractGaranties,
  getContractSanctions,
  getContractFinished,
  getContractDetails
} from '../../services/charts'

export const CONTRACTFILES = 'CONTRACTFILES'
export const CONTRACTFILES_ERROR = 'CONTRACTFILES_ERROR'
export const CONTRACTFILES_SUCCESS = 'CONTRACTFILES_SUCCESS'
export const onContractFiles = makeActionCreator(CONTRACTFILES)
export const onContractFilesError = makeActionCreator(CONTRACTFILES_ERROR, 'payload')
export const onContractFilesSuccess = makeActionCreator(CONTRACTFILES_SUCCESS, 'payload')
export const onContractFilesThunk = (idEntity, year) => async dispatch => {
  dispatch(onContractFiles())

  try {
    const [resGaranties, resSanctions, resFinished] = await Promise.all([
      getContractGaranties({ idEntity, year }),
      getContractSanctions({ idEntity, year }),
      getContractFinished({ idEntity, year })
    ])

    if (resGaranties.data.success !== 'OK') {
      return dispatch(onContractFilesError(resGaranties.data.errores))
    }

    const singleGaranty = resGaranties.data.payload.find(item => item.year === year)
    const singleSanction = resSanctions.data.payload.find(item => item.year === year)
    const singleFinish = resFinished.data.payload.find(item => item.year === year)
    const payload = { Garanties: singleGaranty ?? 0, Sanctions: singleSanction ?? 0, Finished: singleFinish ?? 0 }

    return dispatch(onContractFilesSuccess(payload))
  } catch (error) {
    return dispatch(onContractFilesError(error))
  }
}

export const CONTRACTFILESDETAIL = 'CONTRACTFILESDETAIL'
export const CONTRACTFILESDETAIL_ERROR = 'CONTRACTFILESDETAIL_ERROR'
export const CONTRACTFILESDETAIL_SUCCESS = 'CONTRACTFILESDETAIL_SUCCESS'
export const onContractFilesDetail = makeActionCreator(CONTRACTFILESDETAIL, 'payload')
export const onContractFilesDetailError = makeActionCreator(CONTRACTFILESDETAIL_ERROR, 'payload')
export const onContractFilesDetailSuccess = makeActionCreator(CONTRACTFILESDETAIL_SUCCESS, 'payload')
export const onContractFilesDetailThunk = (idEntity, year, type) => async dispatch => {
  dispatch(onContractFilesDetail())

  try {
    const response = await getContractDetails({ idEntity, year, type })

    if (response.data.success !== 'OK') {
      return dispatch(onContractFilesDetailError(response.data.errores))
    }

    const { data: tableStructure } = response.data.payload.find(item => item.year === year)
    const csvStructures = {
      garantias: {
        body: item => [
          item.contractCode,
          item.warrantyNumber,
          item.warrantyType,
          item.warrantyStatus,
          item.warrantyDocumentType
        ],
        headers: [
          'ID ficha de contrato',
          'Nombre contratoNúmero de garantía',
          'Tipo de garantía',
          'Estado de garantía',
          'Tipo de documento'
        ]
      },
      sanciones: {
        body: item => [
          item.contractCode,
          item.sanctionID,
          // FIXME: endpoint does not provide a sanction type.
          item.sanctionType,
          item.sanctionDate,
          // FIXME: endpoint does not provide a sanction status.
          item.sanctionStatus
        ],
        headers: [
          'ID ficha de contrato',
          'Número de sanción',
          'Tipo de sanción',
          'Fecha de sanción',
          'Estado de sanción'
        ]
      },
      terminados: {
        body: item => [
          item.oc_LIC_Asoc,
          item.contractStart,
          item.contractEnd,
          item.contractExecutionType,
          item.contractStatus
        ],
        headers: [
          'Licitación asociada',
          'Fecha de inicio contrato',
          'Fecha de termino contrato',
          'Tipo de ejecución de contrato',
          'Estado del contrato'
        ]
      }
    }
    const csvStructure = [csvStructures[type].headers, ...tableStructure.map(csvStructures[type].body)]

    return dispatch(onContractFilesDetailSuccess({ csvStructure, tableStructure }))
  } catch (error) {
    return dispatch(onContractFilesDetailError({ error }))
  }
}
